import React from 'react';
import FoldableSection from './FoldableSection';

interface DescriptionSectionProps {
    expanded: boolean;
    setExpanded: (expanded: boolean) => void;
    disabled?: boolean;
}

const DescriptionSection: React.FC<DescriptionSectionProps> = ({
    expanded,
    setExpanded,
    disabled = false
}) => {
    return (
        <FoldableSection
            title="Deskripsi & Catatan Penting"
            expanded={expanded}
            setExpanded={setExpanded}
            disabled={disabled}
            halfFolded={true}
        >
            <div className="product-description">
                <p>{`Praktikkan bahasa Korea dengan mahasiswa ramah yang merupakan penutur asli. Sesi 1-on-1 yang dipersonalisasi ini dirancang untuk membantu Anda meningkatkan keterampilan berbicara dalam lingkungan yang nyaman.`}</p>
                
                <h3>{`Yang termasuk:`}</h3>
                <ul>
                    <li>{`30 menit latihan percakapan khusus`}</li>
                    <li>{`Umpan balik personal untuk pengucapan dan tata bahasa`}</li>
                    <li>{`Wawasan budaya dan ekspresi otentik`}</li>
                    <li>{`Catatan sesi dengan kosakata utama`}</li>
                    <li>{`Penjadwalan fleksibel dalam 2 minggu setelah pembelian`}</li>
                </ul>
            </div>
            
            <div className="product-warnings">
                <h3>{`Catatan Penting:`}</h3>
                <ul>
                    <li>{`Sesi harus dijadwalkan minimal 24 jam sebelumnya`}</li>
                    <li>{`Tiket kedaluwarsa 30 hari setelah pembelian`}</li>
                    <li>{`Pembatalan kurang dari 12 jam sebelum sesi tidak dapat dikembalikan`}</li>
                    <li>{`Koneksi internet dan perangkat dengan kamera/mikrofon diperlukan`}</li>
                    <li>{`Sesi dilakukan melalui platform aman kami`}</li>
                    <li>{`Pengetahuan dasar bahasa Korea direkomendasikan untuk pengalaman terbaik`}</li>
                </ul>
            </div>
        </FoldableSection>
    );
};

export default DescriptionSection;